import { render, staticRenderFns } from "./MyGoals.vue?vue&type=template&id=715a3494"
import script from "./MyGoals.vue?vue&type=script&lang=js"
export * from "./MyGoals.vue?vue&type=script&lang=js"
import style0 from "./MyGoals.vue?vue&type=style&index=0&id=715a3494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports